(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchCustomerSearch', PatchCustomerSearch);

    PatchCustomerSearch.$inject = ['$resource'];

    function PatchCustomerSearch($resource) {
        var resourceUrl =  'api/_search/patch-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
